<script setup lang="ts">
import { ref, h } from 'vue';
import { useComponentComposable } from '@/components/useComponentComposable';
import Dialog from 'primevue/dialog';
import LongParagraphModal from '@/components/modal/utils/LongParagraphModal.vue';
import ShowImageByScreen from '@/components/ShowImageByScreen.vue';

interface Props {
  products: any;
}
defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();
const position = ref<any>('center');
const displayResponsive = ref(false);
const dialogIndex = ref();

const renderTermsAndConditionsHtml = (e) => {
  return h('div', { class: 'english-term', innerHTML: e.term });
};

const openResponsive = (pos, index) => {
  position.value = pos;
  dialogIndex.value = index;
  displayResponsive.value = true;
};
</script>
<template>
  <div class="product-item max-w-400px">
    <div class="product-item-content">
      <ShowImageByScreen alt="image-render" class="w-full border-round-top max-h-24rem" :images="products.renderImage"></ShowImageByScreen>
      <div class="mt-3 mb-0 px-3 flex">
        <renderHTMLContent class="font-bold text-3xl heading-font text-900 my-2" :data="products.title"></renderHTMLContent>
      </div>
      <div class="text-left px-3 py-3">
        <LongParagraphModal class-component="break-word overflow-hidden max-h-13rem" :text="products.description" />
        <a v-if="products.terms" class="tAndC cursor-pointer" @click="openResponsive('center', products.index)">{{ $t('promos.labels.term') }}</a>
        <Dialog :header="$t('common.termcondition')" :modal="true" v-model:visible="displayResponsive" v-if="products.index === dialogIndex" :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :position="position" class="tcs side-promo-term">
          <renderTermsAndConditionsHtml :term="products.terms"></renderTermsAndConditionsHtml>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
:deep(.tAndC) {
  display: block;
  text-decoration: underline;
  margin-top: 20px;
  color: $col-black !important;
}

:deep() {
  .product-item {
    ul {
      list-style: disc;

      li::marker {
        color: $col-red;
        background-color: $col-red;
      }
    }
  }
}

:deep(.product-item-content ul) {
  padding: revert !important;
}
</style>
